import { render, staticRenderFns } from "./VideoPop.vue?vue&type=template&id=1d9453dc&scoped=true&"
import script from "./VideoPop.vue?vue&type=script&lang=js&"
export * from "./VideoPop.vue?vue&type=script&lang=js&"
import style0 from "./VideoPop.vue?vue&type=style&index=0&id=1d9453dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9453dc",
  null
  
)

export default component.exports